import { useEffect, useRef, useState } from "react";

export default function ChipMultiSelect({ label, options, selected, onChange, emptyText }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return;
    const onDocClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onDocClick);
    return () => document.removeEventListener("mousedown", onDocClick);
  }, [open]);

  const toggle = (value) => {
    const set = new Set(selected || []);
    if (set.has(value)) set.delete(value);
    else set.add(value);
    onChange(Array.from(set));
  };

  const count = selected?.length || 0;

  return (
    <div ref={ref} style={{ position: "relative", display: "inline-block" }}>
      <button
        onClick={() => setOpen((v) => !v)}
        style={{
          ...btn,
          borderColor: count > 0 ? "#7B5AC4" : "#E2E8F0",
          background: count > 0 ? "#EEF2FF" : "white",
          color: count > 0 ? "#4338CA" : "#475569",
        }}
      >
        {label}
        {count > 0 && (
          <span style={countBadge}>{count}</span>
        )}
        <span style={{ marginLeft: 4, opacity: 0.6 }}>▾</span>
      </button>
      {open && (
        <div style={menu}>
          {!options || !options.length ? (
            <div style={menuEmpty}>{emptyText || "No options"}</div>
          ) : (
            options.map((opt) => {
              const isSelected = (selected || []).includes(opt.value);
              return (
                <label key={opt.value} style={menuItem}>
                  <input
                    type="checkbox"
                    checked={isSelected}
                    onChange={() => toggle(opt.value)}
                    style={{ marginRight: 6 }}
                  />
                  <span style={{ flex: 1 }}>{opt.label}</span>
                  {opt.count != null && (
                    <span style={menuCount}>{opt.count}</span>
                  )}
                </label>
              );
            })
          )}
        </div>
      )}
    </div>
  );
}

const btn = {
  padding: "6px 10px",
  borderRadius: 6,
  border: "1px solid #E2E8F0",
  fontSize: 11,
  fontWeight: 600,
  cursor: "pointer",
  display: "inline-flex",
  alignItems: "center",
  gap: 4,
  background: "white",
};
const countBadge = {
  background: "#7B5AC4",
  color: "white",
  fontSize: 10,
  fontWeight: 700,
  padding: "0 5px",
  borderRadius: 100,
  minWidth: 14,
  textAlign: "center",
  marginLeft: 4,
};
const menu = {
  position: "absolute",
  top: "calc(100% + 4px)",
  left: 0,
  background: "white",
  border: "1px solid #E2E8F0",
  borderRadius: 6,
  boxShadow: "0 8px 24px rgba(15, 23, 42, 0.12)",
  zIndex: 50,
  minWidth: 180,
  maxHeight: 280,
  overflowY: "auto",
  padding: 4,
};
const menuItem = {
  display: "flex",
  alignItems: "center",
  padding: "6px 8px",
  fontSize: 12,
  color: "#0F172A",
  cursor: "pointer",
  borderRadius: 4,
};
const menuCount = {
  fontSize: 10,
  color: "#94A3B8",
  fontWeight: 600,
};
const menuEmpty = {
  padding: "10px 8px",
  fontSize: 11,
  color: "#94A3B8",
  textAlign: "center",
};
